import React from "react"
export function UpChevronFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 18c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8 3.589 8 8 8zm3.5-6.186L9.993 8.747l-3.505 3.067-.988-1.128 4-3.5.089-.067a.75.75 0 01.81 0l.089.067 4 3.5-.988 1.128z"
        fill="currentColor"
        id="prefix__up-chevron---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
